import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import NewsNodePlaceholder from './components/NewsNodePlaceholder';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "NewsNode" */ './lazyIndex'));

export let NewsPane = createLazyComponent(lazyModule, m => m.NewsPane);
export let NewsCommandingBar = createLazyComponent(lazyModule, m => m.NewsCommandingBar);
export let NewsNode = createLazyComponent(
    lazyModule,
    m => m.NewsNode,
    () => NewsNodePlaceholder()
);

export const lazyOnNewsNodeClicked = new LazyAction(lazyModule, m => m.onNewsNodeClicked);
export const lazyOnNewsNodeRightClicked = new LazyAction(lazyModule, m => m.onNewsNodeRightClicked);
export const lazyFetchNewsNotifications = new LazyAction(lazyModule, m => m.fetchNewsNotifications);
export const lazyOnTurnOffNewsClicked = new LazyAction(lazyModule, m => m.onTurnOffNewsClicked);
export { NEWS_ID } from './util/newsConstants';
